import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

// Create a mock client if credentials are missing
const createMockClient = () => {
  console.warn('Supabase credentials not configured. Using mock client.');
  
  // Create chainable query builder
  const createQueryBuilder = () => {
    const builder: any = {
      data: [],
      error: null,
    };
    
    const chainMethods = ['select', 'insert', 'update', 'delete', 'eq', 'order', 'limit', 'single', 'match', 'in', 'neq', 'gt', 'gte', 'lt', 'lte', 'like', 'ilike', 'is', 'contains', 'containedBy', 'range', 'overlaps', 'textSearch', 'filter', 'not', 'or', 'and'];
    
    chainMethods.forEach(method => {
      builder[method] = () => builder;
    });
    
    return builder;
  };
  
  return {
    auth: {
      getUser: () => Promise.resolve({ data: { user: null }, error: null }),
      getSession: () => Promise.resolve({ data: { session: null }, error: null }),
      signInWithPassword: () => Promise.resolve({ data: null, error: new Error('Auth not configured') }),
      signUp: () => Promise.resolve({ data: null, error: new Error('Auth not configured') }),
      signOut: () => Promise.resolve({ error: null }),
      onAuthStateChange: (callback: any) => {
        // Return proper subscription object
        return {
          data: {
            subscription: {
              unsubscribe: () => {}
            }
          }
        };
      },
    },
    from: () => createQueryBuilder(),
    rpc: () => Promise.resolve({ data: null, error: null }),
    channel: () => ({
      on: () => ({ subscribe: () => ({}) }),
    }),
    removeChannel: () => {},
  } as any;
};

export const supabase = supabaseUrl && supabaseAnonKey && supabaseUrl !== 'https://your-project.supabase.co'
  ? createClient(supabaseUrl, supabaseAnonKey)
  : createMockClient();
